import { render } from "./DasboardChartCard.vue?vue&type=template&id=60c0a8e8&scoped=true&ts=true"
import script from "./DasboardChartCard.vue?vue&type=script&lang=ts"
export * from "./DasboardChartCard.vue?vue&type=script&lang=ts"

import "./DasboardChartCard.vue?vue&type=style&index=0&id=60c0a8e8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2602801780/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c0a8e8"]])

export default __exports__